export const REQUEST_AVAILABLE_ARRIVAL_TIME_SLOTS = 'REQUEST_AVAILABLE_ARRIVAL_TIME_SLOTS';
export const RECEIVE_AVAILABLE_ARRIVAL_TIME_SLOTS = 'RECEIVE_AVAILABLE_ARRIVAL_TIME_SLOTS';
export const SET_AVAILABLE_ARRIVAL_TIME_SLOTS_FAILURE = 'SET_AVAILABLE_ARRIVAL_TIME_SLOTS_FAILURE';
export const CLEAR_ARRIVAL_TIME_ERROR_MESSAGE = 'CLEAR__ARRIVAL_TIME_ERROR_MESSAGE';
export const SET_SELECTED_ARRIVAL_TIME = 'SET_SELECTED_ARRIVAL_TIME';
export const REQUEST_ADDING_ARRIVAL_TIME_SLOT = 'REQUEST_ADDING_ARRIVAL_TIME_SLOT';
export const RECEIVE_ADDING_ARRIVAL_TIME_SLOT = 'RECEIVE_ADDING_ARRIVAL_TIME_SLOT';
export const SET_ADDING_ARRIVAL_TIME_SLOT_FAILURE = 'SET_ADDING_ARRIVAL_TIME_SLOT_FAILURE';
export const REQUEST_REMOVE_ARRIVAL_TIME_SLOT = 'REQUEST_REMOVE_ARRIVAL_TIME_SLOT';
export const RECEIVE_REMOVE_ARRIVAL_TIME_SLOT = 'RECEIVE_REMOVE_ARRIVAL_TIME_SLOT';
export const SET_REMOVE_ARRIVAL_TIME_SLOT_FAILURE = 'SET_REMOVE_ARRIVAL_TIME_SLOT_FAILURE';
export const SET_ARRIVAL_PAGE_WAS_BOOKED = 'SET_ARRIVAL_PAGE_WAS_BOOKED';
